// extracted by mini-css-extract-plugin
module.exports = {"tabTotal":"style__tabTotal__NDcpy","tabBreakdown":"style__tabBreakdown__0w6E6"};